import React from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import InputAdornment from '@mui/material/InputAdornment'
import SearchIcon from '@mui/icons-material/Search'
import { useTranslation } from 'react-i18next'
import LanguagePicker from '../tts/LanguagePicker'
import { TtsLanguage } from '../../types/tts'

export interface VoiceFilterState {
  search: string
  language: string
}

interface VoiceFiltersProps {
  filters: VoiceFilterState
  onFilterChange: (filters: VoiceFilterState) => void
  languages: TtsLanguage[]
  languagesLoading?: boolean
}

// Language-first stock browsing (catalog v4): choose a language, then browse that
// language's native voices. A name search narrows within the chosen language.
const VoiceFilters: React.FC<VoiceFiltersProps> = ({
  filters,
  onFilterChange,
  languages,
  languagesLoading = false,
}) => {
  const { t } = useTranslation()

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFilterChange({ ...filters, search: e.target.value })
  }

  const handleSelectLanguage = (code: string) => {
    onFilterChange({ ...filters, language: code })
  }

  return (
    <Box sx={{ mb: 3 }}>
      <LanguagePicker
        languages={languages}
        selectedLanguage={filters.language}
        onSelectLanguage={handleSelectLanguage}
        loading={languagesLoading}
      />
      <TextField
        size="small"
        placeholder={t('searchVoices', 'Search voices...')}
        value={filters.search}
        onChange={handleSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        sx={{ minWidth: 220, mt: 2 }}
      />
    </Box>
  )
}

export default VoiceFilters
